import { CheckCircle2 } from "lucide-react";
import { fmtDate } from "@/lib/checkins";
import { BigButton, UrgentNotice } from "./PublicShell";

export function IntroStep({ data, resuming, onStart }) {
  const t = data.template;
  return (
    <div className="space-y-6" data-testid="checkin-intro">
      {data.assisted && (
        <p className="rounded-lg bg-sky-50 px-4 py-2 text-sm font-semibold text-sky-900" data-testid="checkin-assisted-banner">
          Practitioner-assisted completion
        </p>
      )}
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">About {t.est_minutes} minutes</p>
        <h1 className="mt-2 font-display text-3xl font-bold tracking-tight text-zinc-950 sm:text-4xl">
          Hi {data.first_name || "there"}, here&apos;s your exercise progress review
        </h1>
      </div>
      <p className="text-lg leading-relaxed text-zinc-800">{t.intro}</p>
      <div className="rounded-2xl border border-zinc-200 bg-white p-5 text-lg" data-testid="checkin-period">
        Think about the <strong>last {t.period_days} days</strong>: {fmtDate(data.period.start)} – {fmtDate(data.period.end)}.
      </div>
      <p className="text-base leading-relaxed text-zinc-700">
        Your answers save automatically, so you can stop and come back using the same link. This is not an emergency
        service — if you have urgent or severe symptoms, call 000 or seek medical help rather than waiting for a reply.
      </p>
      <BigButton className="w-full" onClick={onStart} data-testid="checkin-start-btn">{resuming ? "Continue" : "Start"}</BigButton>
    </div>
  );
}

export function DoneStep({ result }) {
  return (
    <div className="space-y-5" data-testid="checkin-done">
      <CheckCircle2 className="h-12 w-12 text-emerald-700" aria-hidden="true" />
      <h1 className="font-display text-3xl font-bold tracking-tight text-zinc-950">Thank you — your progress review has been sent</h1>
      <UrgentNotice text={result.urgent_notice} testId="checkin-done-urgent" />
      {result.safety_notice && <p className="text-lg leading-relaxed text-zinc-800" data-testid="checkin-done-safety">{result.safety_notice}</p>}
      {result.released
        ? <p className="text-lg leading-relaxed text-zinc-800" data-testid="checkin-done-released">Your summary is ready. We&apos;ve emailed you a secure link to view it.</p>
        : <p className="text-lg leading-relaxed text-zinc-800" data-testid="checkin-done-held">{result.held_notice || "Your exercise team will review your answers and share your summary."}</p>}
      {result.contact_requested && (
        <p className="rounded-xl bg-white p-4 text-lg text-zinc-800" data-testid="checkin-done-contact">
          We&apos;ve let your exercise practitioner know you&apos;d like them to contact you.
        </p>
      )}
      <p className="text-base text-zinc-600">You can close this page.</p>
    </div>
  );
}
